
    <div class="row" [hidden]="msgHead.msg == ''">
      <div class="col-lg-8 col-md-6 col-xs-12">
          <alert [alert]="msgHead"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-6 col-md-6 col-xs-12">
          <alert [alert]="msg" style="display:block;"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-8 col-md-7 col-xs-12">
          <button type="button" class="btn btn-large btn-primary" (click)="add()">Add New</button>
          <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
      </div>
    </div>
    <div class="col-lg-8 col-md-12 col-xs-12">
      <div class="card">
        <table class="table">
          <thead>
            <tr>
                <th>Name</th>
                <th>Domain Names</th>
                <th>User Provisioning</th>
                <th>Protocol</th>
                <th>Updated At</th>
                <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data; let i = index">
              <td style="width:15%;">{{ row.name }}</td>
              <td style="width:15%;">{{ row.domainNames }}</td>
              <td style="width:15%;">
                <span class="btn-link" style="cursor: pointer;" (click)="updateProvisioning(row)">
                  {{ row.userProvisioning==false ? 'Enable' : 'Disable' }}
                </span>
              </td>
              <td style="width:15%;">{{ row.protocol }}</td>
              <td style="width:15%;">{{ printDate(row.updatedAt) ? printDate(row.updatedAt) : printDate(row.createdAt) }}</td>
              <td style="width:25%;">
                  <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                  <span title="Test" class="btn-link" style="cursor: pointer;" (click)="endpoints(row)">Endpoints</span> |
                  <span title="Remove IdP" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="remove(row)" style="cursor:pointer;"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  